import gql from 'graphql-tag'

export const GET_ORGANIZATION_EVENT_TEMPLATE = gql`
  query GetOrganizationEventTemplate($organizationSlug: String!, $eventTemplateId: ID!) {
    getOrganizationEventTemplate(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      durationInMins
      break
      eventCategoryId
      cover
      description
      tagIds
      webLink
      genreId
      facebookLink
      youtubeLink
      instagramLink
      events {
        id
        interests {
          id
        }
      }
    }
  }
`
export const CREATE_EVENT_TEMPLATE_AND_PERFORMANCE = gql`
  mutation CreateEventTemplateAndPerformance(
    $organizationSlug: String!
    $eventTemplateInput: EventTemplateInput!
    $performanceInput: [PerformanceInput!]!
  ) {
    createEventTemplateAndPerformance(
      organizationSlug: $organizationSlug
      eventTemplateInput: $eventTemplateInput
      performanceInput: $performanceInput
    )
  }
`

export const UPDATE_EVENT_TEMPLATE_AND_PERFORMANCE = gql`
  mutation UpdateEventTemplateAndPerformance(
    $organizationSlug: String!
    $eventTemplateInput: EventTemplateInput!
    $publishChanges: Boolean
  ) {
    updateEventTemplateAndPerformance(
      organizationSlug: $organizationSlug
      eventTemplateInput: $eventTemplateInput
      publishChanges: $publishChanges
    )
  }
`
export const GET_ORGANIZATION_EVENT_TEMPLATE_AND_LOGGED_USER = gql`
  query GetOrganizationEventTemplate($organizationSlug: String!, $eventTemplateId: ID!) {
    getOrganizationEventTemplate(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      durationInMins
      break
      eventCategoryId
      cover
      description
      tagIds
      webLink
      genreId
      facebookLink
      youtubeLink
      instagramLink
      events {
        status
        from
        slug
        extraModules {
          ticketing
        }
        interests {
          id
        }
      }
    }
    me {
      id
      firstName
      lastName
      type
      flags
      isVerifiedByCoreEvent
    }
  }
`

export const UPDATE_EVENT_TEMPLATE_COVER = gql`
  mutation UpdateEventTemplateCover($organizationSlug: String!, $eventTemplateId: ID!, $cover: String) {
    updateEventTemplateCover(organizationSlug: $organizationSlug, eventTemplateId: $eventTemplateId, cover: $cover)
  }
`
